/* Live enquiries for the backoffice inbox — newest first. Admin-only
   (rules enforce it). Provides mark-read and delete. */
import { useEffect, useState } from 'react'
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  doc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore'
import { db } from '../lib/firestore.js'

export function useEnquiries() {
  const [enquiries, setEnquiries] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const q = query(collection(db, 'enquiries'), orderBy('createdAt', 'desc'))
    return onSnapshot(
      q,
      (snap) => {
        setEnquiries(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
        setLoading(false)
      },
      () => setLoading(false),
    )
  }, [])

  const markRead = (id) => updateDoc(doc(db, 'enquiries', id), { read: true })
  const markUnread = (id) => updateDoc(doc(db, 'enquiries', id), { read: false })
  const remove = (id) => deleteDoc(doc(db, 'enquiries', id))
  const unreadCount = enquiries.filter((e) => !e.read).length

  return { enquiries, loading, unreadCount, markRead, markUnread, remove }
}
